import { RATING_FORM_UI_VERSION_TS1_V3, RATING_FORM_UI_VERSION_TS1_V4 } from "src/app/constant";

export type Ts1ReportUiKey = "v3" | "v4";

export const TS1_REPORT_UI_REGISTRY = {
	[RATING_FORM_UI_VERSION_TS1_V3]: { ui: "v3" as const },
	[RATING_FORM_UI_VERSION_TS1_V4]: { ui: "v4" as const },
} as const;

export function resolveTs1ReportUiKey(formVersion?: number | null): Ts1ReportUiKey | null {
	const entry = TS1_REPORT_UI_REGISTRY[Number(formVersion) as keyof typeof TS1_REPORT_UI_REGISTRY];
	return entry?.ui ?? null;
}
